import { ViewHTMLModalProps } from './ViewHTMLModal';
import { openModal } from '@core/components/ModalStack';

export async function openViewHTMLModal(props: ViewHTMLModalProps) {
  const { ViewHTMLModal } = await import('./ViewHTMLModal');

  openModal(ViewHTMLModal, props);
}
